export default {
  recent7: '最近七天',
  recent30: '最近三十天',
  recent1y: '最近一年',
  recent5y: '最近五年'
}